import {
    apiRequest,
    createperioderevisikeuangan
} from "../../../../../services/adapters/kepegawaian/revisikeuanganService"

class CreateRepository {

    fetchCreate = async (query) => {
        return await apiRequest("post", createperioderevisikeuangan, {
            body: query
        }, true)
    }


}

export default CreateRepository